module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-2.e48d07a8.png";